import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Loading from '../../../shared/loading';
import { lighten } from '../../../shared/color';
import { enableFeature, disableFeature } from '../../../services/lwadmin/profile/profile-features-service';

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
`;

const Button = styled.button`
  background: ${props => props.theme.primaryColor} 0% 0% no-repeat padding-box;
  color: ${props => props.theme.bodyBackgroundColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 26px;
  border-radius: 4px;
  margin-right: 5px;

  &.inactive {
    background: ${props => lighten(props.theme.primaryColor, 0.9)} 0% 0% no-repeat padding-box;
    color: ${props => props.theme.primaryColor};
  }

  &:focus {
    outline: none;
  }
`;

const FeatureName = styled.div`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 18px;
  margin-top: 5px;
  width: 50%;
  min-width: 240px;
  max-width: 400px;
`;

export default function FeatureControl(props) {
  const { feature, profileFeature, profileId } = props;
  const [isEnable, setIsEnable] = React.useState(profileFeature ? profileFeature.active : false);
  const enableLoadingRef = React.useRef();
  const disableLoadingRef = React.useRef();

  React.useEffect(() => {
    enableLoadingRef.current && enableLoadingRef.current.stop();
    disableLoadingRef.current && disableLoadingRef.current.stop();
  }, [isEnable]);

  const enable = e => {
    e.preventDefault();

    enableLoadingRef.current.start();

    enableFeature(profileId, feature).then(() => {
      setIsEnable(true);
    });
  };

  const disable = e => {
    e.preventDefault();

    disableLoadingRef.current.start();

    disableFeature(profileId, feature).then(() => {
      setIsEnable(false);
    });
  };

  return (
    <Container>
      <FeatureName>{feature}</FeatureName>
      <ButtonGroup>
        <Loading ref={enableLoadingRef} variant="button">
          <Button
            className={isEnable ? '' : 'inactive'}
            disabled={isEnable}
            onClick={enable}
          >
            ON
          </Button>
        </Loading>
        <Loading ref={disableLoadingRef} variant="button">
          <Button
            className={isEnable ? 'inactive' : ''}
            disabled={!isEnable}
            onClick={disable}
          >
            OFF
          </Button>
        </Loading>
      </ButtonGroup>
    </Container>
  );
}

FeatureControl.propTypes = {
  profileId: PropTypes.number.isRequired,
  feature: PropTypes.string.isRequired,
  profileFeature: PropTypes.shape({
    feature: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
  }),
};

FeatureControl.defaultProps = {
  profileFeature: null,
};
